import router from "../routing/router";

export default {
  id: "GTM-TN3C9MN",
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  ignoredViews: [
    "changePassword",
    "resetPassword",
    "dashboard",
    "bookings",
    "booking",
    "vendors",
    "services",
    "categories",
    "profile",
    "settings",
    "customers",
    "customer",
    "orders",
    "order",
    "images",
    "Applications",
    "View Application"
  ]
};
